import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Alert, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Renuncias from '../../../components/contas/renuncia'


function RenunciasScreen() {
    return (
        <Fragment>
            <Head titulo="Renúncias de Receita anuais da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/renuncias'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
               <Renuncias />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default RenunciasScreen;